import { toast } from 'react-toastify';
import { RESEND_SUCCESS_MESSAGE_POPOVER_AUTOCLOSE_TIME } from '@/utils/constants/constants';
import { COLORS } from '@/utils/constants/colors';

export const errorToasterMessage = (message: string) => toast.error(message, {
    icon: () => <em className="fs-4 icon ni ni-cross-circle-fill"></em>,
    position: "top-center",
    toastId:'toaster-container',
    autoClose: RESEND_SUCCESS_MESSAGE_POPOVER_AUTOCLOSE_TIME,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className:'toaster',
    style: {
        backgroundColor: 'rgb(255, 238, 233)',
        borderColor: 'rgba(209, 50, 57, 0.27) rgba(209, 50, 57, 0.27) rgba(209, 50, 57, 0.27) rgb(209, 50, 57)',
        color: 'rgb(178, 43, 49)'   
    }
});

export const infoToasterMessage = (message: string) => toast.info(message, {
    position: "top-center",
    toastId:'toaster-container',
    autoClose: RESEND_SUCCESS_MESSAGE_POPOVER_AUTOCLOSE_TIME,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className:'toaster',
    style: {
        backgroundColor: COLORS.infoBg,
        borderColor: COLORS.info,
        color: COLORS.info
    }
});
export const successToasterMessage = (message: string) => toast.success(message, {
    icon: () => <em className="fs-4 icon ni ni-check-circle-fill"></em>,
    position: "top-center",
    toastId:'toaster-container',
    autoClose: RESEND_SUCCESS_MESSAGE_POPOVER_AUTOCLOSE_TIME,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className:'toaster',
    style: {
        backgroundColor: COLORS.successTint,
        borderColor: COLORS.successAlt,
        color: COLORS.successAlt
    }
});
export const warningToasterMessage = (message: string) => toast.warning(message, {
    icon: () => <em className="fs-4 icon ni ni-alert-circle-fill"></em>,
    position: "top-center",
    toastId:'toaster-container',
    autoClose: RESEND_SUCCESS_MESSAGE_POPOVER_AUTOCLOSE_TIME,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className:'toaster',
    style: {
        backgroundColor: COLORS.warningTint,
        borderColor: 'rgb(255, 79, 0)',
        color: 'rgb(255, 79, 0)',
    }
});